import { j as c } from "../../../../jsx-runtime-B6kdoens.js";
import { a as d } from "../../../../index-CROKJrb5.js";
import { c as g, f as l } from "../../../../create-component-CBAeEoQ6.js";
import { Link as h } from "../../../Link/index.js";
import { useCallback as x } from "react";
import { u as w } from "../../../../NavigationDropdownState-CxCC5dTJ.js";
import { useBrand as b } from "../../../../brand/context/index.js";
import { a as v } from "../../../../react-B_GApDuV.js";
const A = ({
  brand: t,
  size: o
}) => t === "curology" ? o === "md" ? "bold" : "normal" : "light", B = g(
  "NavigationDropdownItem",
  l(
    ({
      children: t,
      className: o,
      closeOnClick: e = !0,
      onClick: r,
      size: m = "md",
      ...n
    }, s) => {
      const i = b(), { openAtom: u } = w(), a = v(u), p = x(
        (f) => {
          e && a(!1), r == null || r(f);
        },
        [e, r, a]
      );
      return /* @__PURE__ */ c.jsx(
        h,
        {
          ref: s,
          className: d(
            "cur-flex cur-items-center cur-gap-2 cur-no-underline hover:cur-underline",
            o
          ),
          onClick: p,
          weight: A({ brand: i, size: m }),
          size: m === "md" ? "subhead" : "meta",
          ...n,
          children: t
        }
      );
    }
  )
);
export {
  B as NavigationDropdownItem
};
//# sourceMappingURL=index.js.map
